import { IRuleRowModel, RuleStatus } from '@cbridge-tools/rules-data-grid';

export const makeNewRowAtIndex = <R extends IRuleRowModel,>(row: R, index: number) => ({
  ...row, id: Date.now(), index: index, status: RuleStatus.Added,
});
